import ENACHUmrnUplaodActionTypes from './nach-umrn-link.type';

// enach export details
export const fetchENACHExportDetailsStart = (getData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_START,
	payload: getData,
});

export const fetchENACHExportDetailsSuccess = (successData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchENACHExportDetailsFailure = (failureData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchENACHExportDetailsResponseReset = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_RESPONSE_RESET,
});

export const fetchENACHExportDetailsResponseChanged = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_EXPORT_DETAILS_RESPONSE_CHANGED,
});

// umrn upload
export const fetchENACHUMRNUploadStart = (getData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_START,
	payload: getData,
});

export const fetchENACHUMRNUploadSuccess = (successData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_SUCCESS,
	payload: successData,
});

export const fetchENACHUMRNUploadFailure = (failureData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_FAILURE,
	payload: failureData,
});

export const fetchENACHUMRNUploadResponseReset = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_RESPONSE_RESET,
});

export const fetchENACHUMRNUploadResponseChanged = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_UMRN_UPLOAD_RESPONSE_CHANGED,
});

// Payment upload
export const fetchENACHPaymentUploadStart = (getData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_START,
	payload: getData,
});

export const fetchENACHPaymentUploadSuccess = (successData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_SUCCESS,
	payload: successData,
});

export const fetchENACHPaymentUploadFailure = (failureData: any) => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_FAILURE,
	payload: failureData,
});

export const fetchENACHPaymentUploadResponseReset = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_RESET,
});

export const fetchENACHPaymentUploadResponseChanged = () => ({
	type: ENACHUmrnUplaodActionTypes.FETCH_ENACH_PAYMENT_UPLOAD_RESPONSE_CHANGED,
});
